/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StatContent } from '../../models/stat-content';
import { StatContentApiRespModel } from '../../models/stat-content-api-resp-model';

export interface ApiMasterStatContentEditPost$Params {
      body?: StatContent
}

export function apiMasterStatContentEditPost(http: HttpClient, rootUrl: string, params?: ApiMasterStatContentEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<StatContentApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterStatContentEditPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StatContentApiRespModel>;
    })
  );
}

apiMasterStatContentEditPost.PATH = '/api/Master/StatContent/Edit';
